exports.install = (Vue, options) => {
	Vue.prototype.$getHtml = function(html) {
		if(!html) html = ''
		return html.replace(/\r\n/ig, '<br/>').replace(/\r/ig, '<br/>').replace(/\n/ig, '<br/>')
	}
}